module.exports = __webpack_public_path__ + "static/media/cosentino-global-icon-c.7f3097e7.svg";